// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"778":"bbc745bd","831":"534d9cf2","877":"4d147aa1"}[chunkId] + ".chunk.js";
};